export const accessRules = {
  superadmin: {
    sidebar: [
      "dashboard",
      "mp",
      "game-calendar",
      "analytics",
      "registrations",
      "sports",
      "branding-kit",
      "sop-guide-add",
    ],
    routes: [
      "/admin",
      "/admin/dashboard",
      "/admin/mp",
      "/admin/game-calendar",
      "/admin/analytics",
      "/admin/branding-kit",
      "/admin/registrations",
      "/admin/sports",
      "/admin/sop-guide/list",
    ],
  },

  "Member of Parliament": {
    sidebar: [
      "dashboard",
      "members",
      "game-calendar",
      "registrations",
      // "sop-guide",
      // "branding-kit",
      "game-selection",
      // "settings",
      "help-centre",
      "user-guide",
      "media",
    ],
    routes: [
      "/admin",
      "/admin/members",
      "/admin/registrations",
      "/admin/dashboard",
      "/admin/game-calendar",
      "/admin/game-selection",
      // "/admin/sop-guide",
      // "/admin/branding-kit",
      "/admin/settings",
      "/admin/help-centre",
      "/admin/user-guide",
      "/admin/media",
    ],
  },
  Member: {
    sidebar: [
      "dashboard",
      "game-calendar",
      "registrations",
      "sop-guide",
      "branding-kit",
      "analytics",
      "settings",
      "help-centre",
      "user-guide",
      "media",
    ],
    routes: [
      "/admin",
      "/admin/registrations",
      "/admin/dashboard",
      "/admin/game-calendar",
      "/admin/sop-guide",
      "/admin/branding-kit",
      "/admin/analytics",
      "/admin/settings",
      "/admin/help-centre",
      "/admin/user-guide",
      "/admin/media",
    ],
  },
  user: {
    sidebar: ["dashboard", "profile"],
    routes: ["/", "/dashboard", "/profile"],
  },
};

export const getAccessRules = (role, selectedStore) => {
  const base = accessRules[role] || { sidebar: [], routes: [] };

  if (role === "superadmin" && selectedStore) {
    const storeRules = accessRules["storeadmin"];
    return {
      sidebar: [...new Set([...base.sidebar, ...storeRules.sidebar])],
      routes: [...new Set([...base.routes, ...storeRules.routes])],
    };
  }

  return base;
};
